<template>
  <custom-dialog class="location-set-dialog" :title="model.title" width="500px" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules" :validate-on-rule-change="false">
        <el-row>
          <el-col>
            <el-form-item :label="$t('dms_location_set_dialog.qjmjot', [$formatLenUnit()])" prop="goalArea">
              <el-input v-model="form.goalArea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('dms_location_set_dialog.qjscmint')" prop="goalTime">
              <el-input v-model="form.goalTime"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: {},
  data() {
    return {
      inputVisible: false,
      inputValue: '',
      form: {
        // 目标面积
        goalArea: '',
        // 目标时长（分钟）
        goalTime: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        goalArea: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        goalTime: [
          {
            required: true,
            message: this.$t('Common.com_required')
          },
        ],
      };
    },
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.edit();
    },
    edit() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.form.goalArea = this.$formatLenUpload(this.form.goalArea);
          this.form.siteIdList = this.model.data.map((item) => item.siteId);
          this.$postJSON(apis.locationSiteSetGoalSelfBatch, this.form, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.$emit('success');
            this.closeDialog();
          });
        }
      });
    },

    initForm() {
      if (this.model.type === 'add') {
        return;
      }
      this.$setFormatData(this.form, this.model.data, 'siteId,siteName,locationId');
      // this.form.goalArea = this.$formatLenLocal(this.form.goalArea);
      // this.getProjectInfo();
    },
  },
  mounted() {
    this.initForm();
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.location-set-dialog {
}
</style>
